import React from 'react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Form, Modal, Select } from 'antd';
import { ICommitter, IContributor } from '../store/Contributors';

type ModalAction = 'merge' | 'attach';

interface IShowModalProps {
  action: ModalAction;
  source: IContributor | ICommitter;
  options: { label: string, value: string | number }[];
  onOk?: (action: ModalAction, source: IContributor | ICommitter, destinationId: string) => Promise<void>;
}

class SelectContributorModalStore {
  state?: IShowModalProps;
  visible = false;

  constructor() {
    makeObservable(this, {
      visible: observable,
      state: observable,
      show: action,
    });
  }

  show(props: IShowModalProps) {
    this.visible = true;
    this.state = {
      action: props.action,
      source: props.source,
      options: props.options,
      onOk: props.onOk,
    };
  }
}

const store = new SelectContributorModalStore();
export { store as selectContributorModalStore };

export const SelectContributorModal = observer(() => {
  const getTitle = () => {
    switch (store?.state?.action) {
      case 'attach': return 'Attach committer to contributor';
      case 'merge': return 'Merge contributors';
      default: return 'Unknown operation';
    }
  };

  const getMessage = () => {
    switch (store?.state?.action) {
      case 'merge':
        const contributor = store.state.source as IContributor;
        return `Please select a contributor to merge all ${contributor.committers.length} committers of ${contributor.name} to:`;
      case 'attach':
        const committer = store.state.source as ICommitter;
        return `Please select a contributor to attach committer ${committer.author} <${committer.email}> to:`;
      default: return 'Unknown operation';
    }
  };

  const [ form ] = Form.useForm();

  return (
    <Modal
      title={getTitle()}
      open={store.visible}
      okText='Save'
      onOk={async () => {
        try {
          const values = await form.validateFields();
          if (store?.state?.onOk) {
            await store.state.onOk(store.state.action, store.state.source, values.contributorId);
          }
          store.visible = false;
          form.resetFields();
        } catch {
          // drunya: added this because validation throws exception on empty field, though it processes it correctly
        }
      }}
      onCancel={() => {
        store.visible = false;
        form.resetFields();
      }}
    >
      <Form form={form}>
        <p>{getMessage()}</p>
        <Form.Item name='contributorId' rules={ [ { required: true } ] }>
          <Select
            showSearch
            options={store.state?.options}
            style={{ width: '100%', marginTop: '24px' }}
            placeholder="Search by name"
            filterOption={(input, option) =>
              (option?.label as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />

        </Form.Item>
      </Form>
    </Modal>
  );
});
